import {
    // apiRequest,
    polaKerjaPegawaiList,
    polaKerjaPegawaiActive,
    polaKerjaPegawaiInactive
} from "../../../../../services/adapters/kepegawaian/polaKerjaPegawaiService"
import {
    apiRequest,
    pejabatPenetapList,
    pejabatPenetapActive,
    pejabatPenetapInactive
} from "../../../../../services/adapters/kepegawaian/pejabatPenetapService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", pejabatPenetapList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", pejabatPenetapInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", pejabatPenetapActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository